import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'cdp-fe-commons-layout/dist/cdp-fe-commons-layout.css'
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import './assets/custom-bootstrap-italia.css'
import 'bootstrap-italia/dist/bootstrap-italia.esm';
import 'formiojs/dist/formio.full.min.css';
import 'flatpickr/dist/flatpickr.min.css';
import {createPinia} from "pinia";
import {useLoadingSpinnerStore} from "@/stores/loadingSpinner";
import axios from "./axios/Istanze";
import {useNotificationStore} from "@/stores/notification";
import {INotification} from "@/interfaces/components/general/INotification";
import {NotificationStatus} from "@/enums/components/general/NotificationStatus";
import {NotificationPosition} from "@/enums/components/general/NotificationPosition";
// @ts-ignore
import cdp_fe_commons_layout, {IOptions} from 'cdp-fe-commons-layout'
// @ts-ignore
import {Collapse, Dropdown, NavScroll} from "bootstrap-italia";
import { SERVER_URL_ISTANZE } from '@/requests/common'

declare global {
    interface Window {
        FE_COMMONS_CONFIG?: {
            proxyBaseUrl?: string;
            debug?: boolean;
        };
    }
}

const pinia = createPinia();

/*if (process.env.NODE_ENV === 'development') {
    const { worker } = require('./mocks/browser')
    worker.start()
}*/

export const app = createApp(App)
app.use(pinia)

const loadingSpinnerStore = useLoadingSpinnerStore();

const notificationStore = useNotificationStore();

const crashManager = (error: string) => {
    notificationStore.addNotification({
        title: "Errore dell'applicativo",
        message: "Abbiamo riscontrato qualche errore. Verrai reindirizzato alla home.",
        status: NotificationStatus.ERROR,
        position: NotificationPosition.TOP,
        timeout: 1500,
        dismissable: true,
        afterDismissCallback: () => {
            console.error(error);
            loadingSpinnerStore.stopAllLoading();
            router.push("/");
        }
    } as INotification)
};

window.FE_COMMONS_CONFIG = {
    proxyBaseUrl: 'http://localhost:8085/router',
    debug: process.env.VUE_APP_FE_COMMONS_DEBUG === 'true'
};


app.use(cdp_fe_commons_layout, {router: router, Dropdown: Dropdown, Collapse: Collapse, NavScroll: NavScroll} as IOptions)
app.use(axios, {
    baseUrl: SERVER_URL_ISTANZE,
    startLoader: loadingSpinnerStore.startLoading,
    stopLoader: loadingSpinnerStore.stopLoading,
    crashManager: crashManager
})
app.use(router)
app.mount('#app');



